import { Record } from 'immutable';

export type LinkType = {
  href: string;
};
export default Record<LinkType>({
  href: '',
});
